<template>
  <div>
    <!-- <FilterItems :datasIn="freights" @filtered="updatedFreight"></FilterItems> -->
    <md-card>
      <md-card-content>
        <form>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-33 md-xsmall-size-100 mt-4">
              <md-field>
                <label>Almacén</label>
                <md-select
                  :disabled="loading"
                  v-model="fetchParams.warehouseId"
                  name="warehouse"
                  id="warehouse"
                >
                  <md-option
                    v-for="warehouse in fetchedWarehouses"
                    :key="warehouse.id"
                    :value="warehouse.id"
                  >{{ warehouse.name }}</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33 md-xsmall-size-100 mt-4">
              <md-autocomplete
                v-model="dummyParams.provider"
                :md-options="getProviders"
                @md-selected="({ id }) => (fetchParams.provider = id)"
                md-dense
                :disabled="loading"
              >
                <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                  <b>{{ item.provider_number }}</b>
                  ({{ item.name }})
                </template>
                <label>Proveedor</label>
              </md-autocomplete>
            </div>

            <div class="md-layout-item md-size-33 md-xsmall-size-100">
              <md-field>
                <label class="active date-label">Fecha de entrega</label>
                <label for="delivery">
                  <md-icon>calendar_today</md-icon>
                </label>
                <datetime
                  :disabled="loading"
                  v-model="fetchParams.deliveryDate"
                  type="date"
                  name="delivery"
                  id="delivery"
                  input-style="border: none; outline:none; width: 100%; margin-top: 13px;"
                  title="Fecha de entrega"
                  value-zone="America/Mexico_City"
                  :phrases="{ ok: '', cancel: '' }"
                  auto
                ></datetime>
                <md-button
                  class="md-simple md-just-icon"
                  :disabled="loading"
                  @click="fetchParams.deliveryDate = null"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-field>
            </div>
          </div>
        </form>
      </md-card-content>
    </md-card>

    <catalog-table
      :tableHeaders="freightHeaders"
      :tableComponents="freightComponents"
      :tableData="freightData"
      :propsToSearch="freightSearchableProps"
      :page-size="25"
      xactions="freightActions"
    >
      <template slot="search-toolbar-actions">
        <md-button class="md-success" @click="addFreight" :disabled="loading">
          <span class="md-label">
            <md-icon class="material-icons">add</md-icon>
          </span>
          Agregar
        </md-button>
      </template>
      <span slot="subtotalFreight-cell" slot-scope="{ item, value }">{{ value | money }}</span>
      <span slot="totalFreight-cell" slot-scope="{ item, value }">{{ value | money }}</span>
    </catalog-table>

    <modal width="70%" v-if="editModal" @close="editModalHide">
      <template slot="header">
        <h4 class="info-text">{{ editModalTitle }}</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="editModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <freight-edit
          :freight="currentFreight"
          :updating="updating"
          :orders="completePurchaseOrders"
          :fetchedProviders="getProviders"
          @saved="updateFreight"
          @error="hideEdit"
        ></freight-edit>
      </template>
    </modal>
  </div>
</template>

<script>
import PurchaseService from "@/services/purchase";
import catalogService from "@/services/catalog";
import warehouseService from "@/services/purchase/warehouse";
import { CatalogTable } from "@/components/";
import { Modal } from "@/components";
import FreightEdit from "./Edit";
import FilterItems from "./Filter";
import ListOrders from "./FreightOrders";
import FreightFiles from "./FreightFiles";
import FreightTransformer from "../../../transformers/purchase/freight";
import FreightPrice from "./FreightPrice";

const freightHeaders = {
  provider_name: "Proveedor",
  addedDate: "Fecha",
  subtotalFreight: "Subtotal",
  totalFreight: "Total",
  listOrders: "Ordenes de Compra",
  // warehouseName: "Almacén",
  freightFiles: "Factura",
};

export default {
  name: "Freights",
  components: {
    CatalogTable,
    Modal,
    FreightEdit,
    FilterItems,
  },
  data() {
    return {
      loading: false,
      freights: [],
      freightData: [],
      editModal: false,
      currentFreight: {},
      editModalTitle: "Editar Flete",
      updating: Boolean,
      orders: [],
      providers: [],
      completePurchaseOrders: [],
      fetchedWarehouses: [],
      freightFilters: {},
      freightHeaders,
      freightSearchableProps: Object.keys(freightHeaders),
      // freightActions: [
      //   {
      //     icon: "edit",
      //     exe: this.editFreight,
      //   },
      // ],
      freightComponents: {
        listOrders: {
          component: ListOrders,
          bind(listOrders) {
            return listOrders;
          },
        },
        freightFiles: {
          component: FreightFiles,
          bind(freightFiles) {
            return freightFiles;
          },
        },
        freightPrice: {
          component: FreightPrice,
          bind(freightPrice) {
            return freightPrice;
          },
        },
      },
      modelValidations: {
        provider: {
          required: true,
        },
        amount: {
          required: true,
        },
        invoice_number: {
          required: true,
        },
      },
      dummyParams: {
        provider: null,
      },
      fetchParams: {
        asc: true,
        warehouseId: null,
        // revi: null,
        provider: null,
        page: 1,
        pageSize: 10,
        deliveryDate: "",
      },
    };
  },
  computed: {
    getProviders() {
      return this.providers.map((provider) => ({
        ...provider,
        commercialName: provider.commercial_name,
        providerNumber: provider.provider_number,
        toLowerCase: () =>
          provider.provider_number.toLowerCase() || provider.name.toLowerCase(),
        toString: () => provider.provider_number,
      }));
    },
  },
  methods: {
    fetchFreights(fetchParams) {
      this.loading = true;
      PurchaseService.fetchFreight(fetchParams)
        .then((data) => (this.freightData = data))
        .catch((err) => {
          this.freightData = [];
        })
        .finally(() => (this.loading = false));
    },
    updatedFreight(datas) {
      this.freightData = datas;
    },
    editModalHide() {
      this.editModal = false;
    },
    editFreight(f) {
      this.updating = true;
      this.orders = f.orders;
      this.editModalTitle = "Editar Flete";
      this.currentFreight = f;
      this.editModal = true;
    },
    updateFreight({ original, updated }) {
      this.hideEdit();
      if (!original.id) {
        PurchaseService.sendFreight(updated)
          .then((freight) => {
            this.$successMessage({ title: "Flete registrado" });
            this.fetchFreights(this.fetchParams);
          })
          .catch(this.$fireErrorResponse);
      } else {
        PurchaseService.updateFreight(updated.id, updated, original).then(
          (freight) => {
            this.$successMessage({ title: "Flete actualizado" });
            let index = this.freights.indexOf(original);
            this.freights.splice(index, 1, FreightTransformer.fetch(freight));
          },
          this.$fireErrorResponse
        );
      }
    },
    addFreight() {
      this.updating = false;
      this.orders = [];
      this.editModalTitle = "Agregar Flete";
      this.currentFreight = {};
      this.editModal = true;
    },
    hideEdit() {
      this.editModal = false;
    },
  },
  watch: {
    //wtfff
    freights: function () {
      this.freightData = this.freights;
    },
    fetchParams: {
      deep: true,
      handler(params, old) {
        const { warehouseId } = params;
        const { searchQuery } = this;
        this.$router.replace(
          {
            query: {
              folio: !!searchQuery ? searchQuery : undefined,
              almacen: warehouseId,
            },
          },
          () => {}
        );
        this.loading = true;
        Promise.all([
          PurchaseService.fetchFreight({ ...params, searchQuery }),
          // PurchaseService.fetchOcsForFreights(),
        ])
          .then(([freight, purchaseOrders]) => {
            this.freightData = freight;
            // this.completePurchaseOrders = purchaseOrders;
          })
          .catch((err) => {
            this.freightData = [];
          })
          .finally(() => (this.loading = false));

        this.loading = true;
      },
    },
    "dummyParams.provider": {
      handler(value) {
        if (!value && value !== this.fetchParams.provider) {
          this.fetchParams.provider = value;
        }
      },
    },
  },
  mounted() {
    this.loading = true;
    const { almacen: iwarehouseId, folio: searchQuery } = this.$route.query;
    Promise.all([
      warehouseService.fetchiWarehouse(),
      catalogService.fetch("providers"),
      PurchaseService.fetchOcsForFreights(),
    ])
      .then(([warehouses, providers, completeOCs]) => {
        this.fetchedWarehouses = [{ name: "Todos", id: 0 }, ...warehouses];
        this.fetchParams.warehouseId = !!iwarehouseId
          ? iwarehouseId
          : warehouses[0].id;
        this.fetchParams.searchQuery = searchQuery;
        this.$router.replace(
          {
            query: {
              almacen: this.fetchParams.warehouseId,
            },
          },
          () => {}
        );

        this.providers = providers.sort((a, b) => (a.slug < b.slug ? -1 : 1));
        this.completePurchaseOrders = completeOCs;
      })
      .catch(this.$fireErrorResponse)
      .finally(() => (this.loading = false));
  },
};
</script>

<style lang="css" scoped>
.catalog-action {
  floating: right;
}
.md-card {
  z-index: unset;
}
.vdatetime {
  margin-left: 2em;
  width: 100%;
}
.date-label {
  top: -9px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/Freight/index.vue